import { render } from "./ClientClientesNuevo.vue?vue&type=template&id=cbfbe838&scoped=true"
import script from "./ClientClientesNuevo.vue?vue&type=script&lang=js"
export * from "./ClientClientesNuevo.vue?vue&type=script&lang=js"

import "./ClientClientesNuevo.vue?vue&type=style&index=0&id=cbfbe838&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cbfbe838"]])

export default __exports__